import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const ContentContext = createContext(null);
const LOCALE_KEY = "peca_locale";

export function ContentProvider({ children }) {
  const [doc, setDoc] = useState(null); // full multi-locale document
  const [loading, setLoading] = useState(true);
  const [locale, setLocaleState] = useState(localStorage.getItem(LOCALE_KEY) || "pt");

  const [error, setError] = useState(false);

  const fetchContent = async (background = false) => {
    if (!background) setLoading(true);
    setError(false);
    const delays = [0, 1200, 2500];
    let ok = false;
    for (let i = 0; i < delays.length; i++) {
      if (delays[i]) await new Promise((r) => setTimeout(r, delays[i]));
      try {
        const { data } = await api.get("/content", { timeout: 8000 });
        setDoc(data);
        const stored = localStorage.getItem(LOCALE_KEY);
        const locales = data?.locales || ["pt"];
        if (!stored || !locales.includes(stored)) {
          setLocaleState(data?.defaultLocale || locales[0] || "pt");
        }
        ok = true;
        break;
      } catch (e) {
        console.error("Falha ao carregar conteúdo", e);
      }
    }
    setLoading(false);
    if (!ok) setError(true);
  };

  useEffect(() => {
    fetchContent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setLocale = (l) => {
    localStorage.setItem(LOCALE_KEY, l);
    setLocaleState(l);
  };

  const locales = doc?.locales || ["pt"];
  const activeLocale = locales.includes(locale) ? locale : (doc?.defaultLocale || locales[0] || "pt");
  const content = doc ? doc[activeLocale] || doc[doc.defaultLocale] || null : null;

  useEffect(() => {
    document.documentElement.lang = activeLocale;
  }, [activeLocale]);

  return (
    <ContentContext.Provider value={{ content, doc, loading, error, refresh: () => fetchContent(true), retry: () => fetchContent(), locale: activeLocale, setLocale, locales }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() {
  return useContext(ContentContext);
}
